import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconActions = ({
  orientation = 'vertical',
  ...props
}: SvgIconProps & {
  orientation?: 'horizontal' | 'vertical'
}) => {
  let rotateValue

  switch (orientation) {
    case 'horizontal': {
      rotateValue = 'rotate(0deg)'
      break
    }
    case 'vertical': {
      rotateValue = 'rotate(90deg)'
      break
    }
  }

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      sx={{ transform: rotateValue }}
    >
      <circle
        cx="5"
        cy="12"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
      />
      <circle
        cx="12"
        cy="12"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
      />
      <circle
        cx="19"
        cy="12"
        r="2"
        stroke="currentColor"
        fill="none"
        strokeWidth="1.5"
      />
    </SvgIcon>
  )
}
